module.exports = __webpack_public_path__ + "img/Scooter Icon - white.5ff6bbde.svg";